<script lang="ts" setup>
import PopoverOverhauling from "@Resources/js/components/popover/PopoverOverhauling.vue";
import { useTranslation } from "@Resources/js/composables";
import XOverlay from "@Modules/shared/store/XOverlay";

import V2CreateForm from "./V2CreateForm.vue";

const { __ } = useTranslation();
const overlay = XOverlay();
</script>

<template>
  <PopoverOverhauling @close="overlay.hide()">
    <template #title>
      {{ __("overlay.create_form.title") }}
    </template>

    <V2CreateForm />
  </PopoverOverhauling>
</template>
